import React, { Component } from 'react';
import { APIHandler, StorageHandler } from 'C4';
import { contentKeys, storageKeys, userKeys, language, demo } from 'settings';

const changeLanguage = (e) => {
  const { value } = e.target;
  const availableLanguages = language.map(lang => lang.code);
  const langFiles = language.map(lang => lang.langFile);
  StorageHandler.removeKeys(contentKeys);
  StorageHandler.removeKeys(userKeys);
  StorageHandler.save(storageKeys.lang, {
    country: value.substring(3),
    code: value.substring(0, 2),
    langFile: langFiles[availableLanguages.indexOf(value.substring(0, 2))],
  });
  window.location.reload();
};

export default class LangSelect extends Component {
  constructor(props) {
    super(props);

    this.state = {
      languages: [],
      selected: '',
      defaultClass: 'lang__select',
    };

    this.loadLanguages = this.loadLanguages.bind(this);
  }

  componentWillMount() {
    this.loadLanguages();
    StorageHandler.load(storageKeys.lang).then((lang) => {
      this.setState({ selected: `${lang.code}-${lang.country}` });
    });
  }

  loadLanguages() {
    const availableLanguages = language.map(lang => lang.code);
    const langFiles = language.map(lang => lang.langFile);
    StorageHandler.load(storageKeys.lang)
      .then((lang) => {
        if (!lang) {
          APIHandler.getLocation().then((location) => {
            if (location && availableLanguages.includes(location.countryCode.toLowerCase())) {
              StorageHandler.save(storageKeys.lang, {
                country: location.country.replace(' ', '_'),
                code: location.countryCode.toLowerCase(),
                langFile: langFiles[availableLanguages.indexOf(location.countryCode.toLowerCase().substring(0, 2))],
              });
              this.loadLanguages();
            } else {
              StorageHandler.exists(storageKeys.lang).then((localLanguage) => {
                if (!localLanguage) {
                  StorageHandler.save(storageKeys.lang, {
                    country: 'United_States',
                    code: 'en',
                    langFile: 'en',
                  });
                }
              });
            }
          });
        }
        const languageList = language
          .filter(({ countries }) => countries.length > 0)
          .map((dropdownLang, id) => {
            const key = id;

            return dropdownLang.countries.map(country => (
              <option
                id={country}
                value={`${dropdownLang.code}-${country.replace(' ', '_')}`}
                key={`${country}_${key}`}
              >
                {country}
              </option>));
          });
        this.setState({ languages: languageList, selected: `${lang.code}-${lang.country}` });
      });
  }

  render() {
    const { selected, defaultClass, languages } = this.state;

    return (
      <div className="lang__select">
        <select
          value={selected}
          style={{ display: demo || languages.length === 1 ? 'none' : 'block' }}
          onChange={e => changeLanguage(e)}
          className={defaultClass}
        >
          {languages}
        </select>
      </div>
    );
  }
}
